import React from 'react'
import _ from 'underscore'
import { ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import Checkbox from '../../checkbox'
import store from '../../../state/store'

class DeactivateButton extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      reason: null,
      send_mail: false
    }
  }

  onProceed = () => {
    const params = {
      deactivation_reason: this.state.reason,
      send_mail: this.state.send_mail
    }

    store.emit('enquiry:deactivate', this.props.enquiry_id, params)
  }

  onCancel = () => {
    store.emit("ui:enquiry:buttons:deactivate", {open: false})
  }

  onEdit = () => {
    store.emit("ui:enquiry:buttons:deactivate", {open: true})
  }

  onSelectWithEmail = (params) => {
    this.setState({reason: params.value, send_mail: true})
  }

  onSelectWithoutEmail = (params) => {
    this.setState({reason: params.value, send_mail: false})
  }

  render() {
    const options = [
      {value: 'no_response', name: 'No response from client', send_mail: 'optional'},
      {value: 'no_tutor', name: 'No tutor', send_mail: 'optional'},
      {value: 'no_tutor_suggest_online', name: 'No tutor/Suggest online', send_mail: 'optional'},
      {value: 'private_tutor', name: 'Found private tutor', send_mail: 'optional'},
      {value: 'outside_geographic_coverage', name: 'Outside geographic coverage', send_mail: 'optional'},
      {value: 'fees_too_high', name: 'Fees too high', send_mail: 'optional'},
      {value: 'out_of_scope', name: 'Beyond the scope of our services', send_mail: 'optional'},
      {value: 'no_tutor_second_email', name: 'No tutor (weeks later - 2nd email)', send_mail: 'optional'},
      {value: 'no_longer_interested', name: 'No longer interested', send_mail: 'unavailable'},
      {value: 'duplicate_enquiry', name: 'Duplicate enquiry', send_mail: 'unavailable'},
      {value: 'other', name: 'Other', send_mail: 'unavailable'}
    ]

    if (this.props.ui.open)
      return (
        <div>
          <div className="grid gap-4 sm:grid-cols-2">
            <div className="grid content-start gap-2">
              <div className="text-sm font-semibold">With Email</div>
              {_.map(_.select(options, function(option) { return option.send_mail === 'optional'}), (option) => {
                const checked = (this.state.reason === option.value) && (this.state.send_mail === true)
                return (
                  <Checkbox key={option.value} name={option.name} value={option.value} checked={checked} onChange={this.onSelectWithEmail}/>
                )
              })}
            </div>
            <div className="grid content-start gap-2">
              <div className="text-sm font-semibold">Without Email</div>
              {_.map(_.select(options, function(option) { return ['optional','unavailable'].includes(option.send_mail)}), (option) => {
                const checked = (this.state.reason === option.value) && (this.state.send_mail === false)
                return (
                  <Checkbox key={option.value} name={option.name} value={option.value} checked={checked} onChange={this.onSelectWithoutEmail}/>
                )
              })}
            </div>
          </div>
          <div className="mt-4 flex justify-end gap-2">
            <Button variant="outline" size="sm" onClick={this.onCancel}>Cancel</Button>
            <Button variant="destructive" size="sm" onClick={this.onProceed}>Deactivate Enquiry</Button>
          </div>
        </div>
      )
    else
      return (
        <Button variant="destructive" onClick={this.onEdit}>
          Deactivate <ChevronDown className="size-4"/>
        </Button>
      )
  }
}

export default DeactivateButton
